<template>
  <div class="fl-content-ctr">
    <stepper-comp />
    <div class="y-tip_ctr">
      <span v-bind:style="{ color: globalTextColor }">Select your institution from the list below</span>
      <el-popover
        placement="bottom"
        width="320"
        trigger="manual"
        :visible-arrow="showArrow"
        popper-class="y-tips-popup h_tips"
        v-model="tipsVisible"
      >
        <div
          class="y-tips-content"
          v-bind:style="{ background: tipBackgroundColor, color: tipTextColor }"
        >
          <el-row class="tips-title-ctr">
            <el-col :span="20" class="tips-title">Tips</el-col>
            <el-col :span="4" class="tips-close">
              <i class="el-icon-close"></i>
            </el-col>
          </el-row>
          <div class="y-tips-content-head">Account Types</div>
          <div class="y-tips-content-p">You can link all sort of accounts. Some examples are:</div>
          <ul class="y-tips-content-list">
            <li>Checking</li>
            <li>Savings</li>
            <li>Credit Card</li>
            <li>Rewards</li>
            <li>Investments</li>
            <li>Retirement</li>            
          </ul>
        </div>
        <i class="y-tip-icon" slot="reference" @click="showHideTips">&nbsp;</i>
      </el-popover>
    </div>
    <div class="fl-poplar-site-ctr h_popular_sites">
      <el-row justify="space-between" class="fl-poplar-site-row">
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div
                class="siteButton"
                v-bind:style="{
            background: instBackgroundColor
          }"
              >
                <div class="siteLogoImage">
                  <img
                    src="./../../assets/images/institution_logo/LOGO_2852_1_2.svg"
                    alt="Bank of America"
                  />
                </div>
                <div
                  class="siteDisplayName h_site_name"
                  v-bind:style="{
            color: instColor
          }"
                >Bank of America</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div
                class="siteButton"
                v-bind:style="{
            background: instBackgroundColor
          }"
              >
                <div class="siteLogoImage">
                  <img
                    src="./../../assets/images/institution_logo/LOGO_1603_1_2.svg"
                    alt="Citibank onlinecitibankcom"
                  />
                </div>
                <div
                  class="siteDisplayName h_site_name"
                  v-bind:style="{
            color: instColor
          }"
                >Citibank onlinecitibankcom</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div
                class="siteButton"
                v-bind:style="{
            background: instBackgroundColor
          }"
              >
                <div class="siteLogoImage">
                  <img src="./../../assets/images/institution_logo/LOGO_643_1_2.svg" alt="Chase" />
                </div>
                <div
                  class="siteDisplayName h_site_name"
                  v-bind:style="{
            color: instColor
          }"
                >Chase</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div
                class="siteButton"
                v-bind:style="{
            background: instBackgroundColor
          }"
              >
                <div class="siteLogoImage">
                  <img
                    src="./../../assets/images/institution_logo/LOGO_5_1_2.svg"
                    alt="Wells Fargo"
                  />
                </div>
                <div
                  class="siteDisplayName h_site_name"
                  v-bind:style="{
            color: instColor
          }"
                >Wells Fargo</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row justify="space-between" class="fl-poplar-site-row">
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div
                class="siteButton"
                v-bind:style="{
            background: instBackgroundColor
          }"
              >
                <div class="siteLogoImage">
                  <img src="./../../assets/images/institution_logo/LOGO_2305_1_2.svg" alt="KeyBank" />
                </div>
                <div
                  class="siteDisplayName h_site_name"
                  v-bind:style="{
            color: instColor
          }"
                >KeyBank</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div
                class="siteButton"
                v-bind:style="{
            background: instBackgroundColor
          }"
              >
                <div class="siteLogoImage">
                  <img
                    src="./../../assets/images/institution_logo/LOGO_2162_1_2.svg"
                    alt="PNC Bank"
                  />
                </div>
                <div
                  class="siteDisplayName h_site_name"
                  v-bind:style="{
            color: instColor
          }"
                >PNC Bank</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div
                class="siteButton"
                v-bind:style="{
            background: instBackgroundColor
          }"
              >
                <div class="siteLogoImage icon-list">
                  <img src="./../../assets/images/icon/fuel.svg" alt="Add Real Estate" />
                  <img src="./../../assets/images/icon/loans.svg" alt="Add Real Estate" />
                  <img src="./../../assets/images/icon/hobies.svg" alt="Add Real Estate" />
                </div>
                <div
                  class="siteDisplayName h_site_name"
                  v-bind:style="{
            color: instColor
          }"
                >Manually Add Account</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div
                class="siteButton"
                v-bind:style="{
            background: instBackgroundColor
          }"
              >
                <div class="siteLogoImage icon-list">
                  <img src="./../../assets/images/icon/rent.svg" alt="Add Real Estate" />
                </div>
                <div
                  class="siteDisplayName h_site_name"
                  v-bind:style="{
            color: instColor
          }"
                >Add Real Estate</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row justify="space-between" class="fl-poplar-site-row">
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div class="siteButton" v-bind:style="{
            background: instBackgroundColor
          }">
                <div class="siteLogoImage">
                  <img
                    src="./../../assets/images/institution_logo/LOGO_3646_1_2.svg"
                    alt="Capital One"
                  />
                </div>
                <div class="siteDisplayName h_site_name"                     v-bind:style="{
            color: instColor
          }">Capital One</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div class="siteButton" v-bind:style="{
            background: instBackgroundColor
          }">
                <div class="siteLogoImage">
                  <img
                    src="./../../assets/images/institution_logo/LOGO_783_1_2.svg"
                    alt="Regions Bank"
                  />
                </div>
                <div class="siteDisplayName h_site_name" v-bind:style="{
            color: instColor
          }">Regions Bank</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div class="siteButton" v-bind:style="{
            background: instBackgroundColor
          }">
                <div class="siteLogoImage">
                  <img
                    src="./../../assets/images/institution_logo/LOGO_3357_1_2.svg"
                    alt="Navy Federal CU"
                  />
                </div>
                <div class="siteDisplayName h_site_name"                     v-bind:style="{
            color: instColor
          }">Navy Federal CU</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="siteWrapper">
              <div class="siteButton" v-bind:style="{
            background: instBackgroundColor
          }">
                <div class="siteLogoImage">
                  <img src="./../../assets/images/institution_logo/LOGO_4132_1_2.svg" alt="TD Bank" />
                </div>
                <div class="siteDisplayName h_site_name"                     v-bind:style="{
            color: instColor
          }">TD Bank</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>-->
    </div>
    <div class="fl-search-ctr custom-icon h_search_bar">
      <el-input placeholder="Don't see your institution? Search here.">
        <i slot="prefix" class="el-icon-search"></i>
      </el-input>
    </div>
  </div>
</template>

<script>
import FLStepper from './flStepper.vue'
import { custToolHelper } from '../../mixins/custToolHelper'
export default {
  data() {
    return {
      showArrow: false,
      selectedPreviewForm: []
    }
  },
  props: {},
  components: {
    'stepper-comp': FLStepper
  },
  mixins: [custToolHelper],
  computed: {
    tipsVisible: {
      set() {
        this.$store.state.custAppStore.tipsVisible
      },
      get() {
        return this.$store.state.custAppStore.tipsVisible
      }
    },
    tipBackgroundColor() {
      return this.getItemDefaultValue(
        'fl-finapp',
        'tips_background_color',
        'tips'
      )
    },
    tipTextColor() {
      return this.getItemDefaultValue('fl-finapp', 'tips_text_color', 'tips')
    },
    globalTextColor() {
      return this.getItemDefaultValue('applyToAll', 'global_text_color')
    },
    instBackgroundColor() {
      return this.getItemDefaultValue(
        'fl-finapp',
        'button_inst_background_color',
        'inst_buttons'
      )
    },
    instColor() {
      return this.getItemDefaultValue(
        'fl-finapp',
        'button_inst_text_color',
        'inst_buttons'
      )
    }
  },
  methods: {
    showHideTips() {
      if (this.$store.state.custAppStore.tipsVisible) {
        this.$store.state.custAppStore.tipsVisible = false
      } else {
        this.$store.state.custAppStore.tipsVisible = true
      }
    }
  }
}
</script>

<style>
.fl-content-ctr {
  padding: 5px 24px;
  width: 100%;
}
.siteWrapper {
  margin: 16px 10px 10px;
  box-shadow: none;
  width: 162px;
}
.siteButton {
  text-align: center;
  box-shadow: 0 0.07143rem 0.14286rem 0 rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  background-color: #fff;
  cursor: pointer;
}
.siteButton:hover {
  box-shadow: 0 0.07143rem 0.28571rem 0 rgba(0, 0, 0, 0.5);
}
.siteButton img {
  max-height: 26px;
  height: 26px;
  max-width: 118px;
  font-size: 0 !important;
}
.siteLogoImage {
  padding-top: 4px;
  height: 26px;
  line-height: 21px;
}
.siteLogoImage.icon-list img {
  width: 16px !important;
  height: 16px !important;
  margin-right: 12px;
}
.siteLogoImage.icon-list img:last-child {
  margin-right: 0px;
}
.siteDisplayName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 10px;
  line-height: 1rem;
  margin: 4px 0;
  clear: both;
  font-size: 12px;
}
.y-tip_ctr {
  padding: 16px;
}
.el-popover.el-popper.y-tips-popup {
  padding: 0px;
  z-index: 200 !important;
}
.y-tips-content {
  padding: 12px;
  color: #1e1d1c;
}
.tips-title-ctr {
  padding-bottom: 10px;
}
.tips-title {
  font-weight: bold;
}
.tips-close {
  text-align: right;
}
.y-tips-content-head {
  border-bottom: 1px solid #1e1d1c;
  display: inline-block;
  margin-bottom: 6px;
}
.y-tips-content-list li {
  list-style-type: none;
  margin-left: 10px;
}
.fl-search-ctr {
  margin-top: 12px;
}
.fl-search-ctr .el-input__inner {
  border-width: 0;
  border-bottom-width: 1px;
  border-radius: 0;
}
.y-tip-icon {
  background: transparent url('~@/assets/images/icon_tip_UF.svg') 50% no-repeat;
  padding: 8px;
  cursor: pointer;
}
</style>
